import {useState} from 'react'
import {cmsClient} from 'data/cmsClient'
import {transformLookProducts} from 'pages/CustomLook/CustomLook'
import {noLook} from 'pages/CustomLook/placeholderLooks'
import {DebugControls} from './DebugControls'

export const TabDebug = ({showLookCallback, faceScanResults, recommendedProducts}) => {
  const showLooks = Object.entries({0: noLook, ...cmsClient.looks()})
    .map(([id, {name, products}]) => ({
      id,
      name,
      cb: showLookCallback({name, products})
    }))

  const lookProducts = transformLookProducts(recommendedProducts?.sortedList ?? [])
  const topProduct = lookProducts[recommendedProducts?.recommendedIndex]

  return (
    <>
      <CollapsibleSection title="Looks">
        <DebugControls {...{showLooks}} />
      </CollapsibleSection>

      {faceScanResults && <CollapsibleSection title="Face scan results">
        <pre>{JSON.stringify(faceScanResults, undefined, 2)}</pre>
      </CollapsibleSection>}

      {topProduct && <CollapsibleSection title={`Top recommended product (#${recommendedProducts.recommendedIndex})`}>
        <ProductTile category={topProduct.type} name={topProduct.name} />
        <pre>{JSON.stringify(topProduct, undefined, 2)}</pre>
      </CollapsibleSection>}

      {lookProducts.length > 0 && <CollapsibleSection title="Recommended products">
        {lookProducts.map(({ productId, type, name }) => (
          <ProductTile
            category={type}
            name={name}
            key={productId}
          />
        ))}
        <pre>{JSON.stringify(lookProducts, undefined, 2)}</pre>
      </CollapsibleSection>}
    </>
  )
}

const CollapsibleSection = ({title, children}) => {
  const [expanded, setExpanded] = useState(false)
  const toggleCollapsed = () => {
    setExpanded(!expanded)
  }
  return (
    <section>
      <div className="heading size-l" style={{cursor: 'pointer'}} onClick={toggleCollapsed}>
        {title} {expanded ? '▿' : '▹'}
      </div>
      <div className="content size-xs" style={expanded ? {} : {display: 'none'}}>
        {children}
      </div>
    </section>
  )
}

const ProductTile = ({category, name}) => (
  <div className="product-tile">
    <div className="details">
      <div className="category size-s">{category}</div>
      <div className="name size-m">{name}</div>
    </div>
  </div>
)
